/**
 * DB `admin_learning_content_*` 전역 카탈로그(`workspace_id is null`)용 localStorage 키 세그먼트.
 * 워크스페이스 id와 무관하게 동일 캐시를 씁니다.
 */
export const PLATFORM_ADMIN_LEARNING_CONTENT_CACHE_KEY = '__platform__';
